import api from './api.js';

/**
 * Account service wrapper for making API calls
 * for account and authentication methods
 */
class Account {

  /**
     * Constructor
     */
  constructor() {

    // Set up URLs
    this.url = '/account';
    this.url_update_payment_info = '/account/update-payment-info';
    this.url_subscription = '/account/subscription';
    this.url_subscription_swap = '/account/subscription/swap';
    this.url_subscription_resume = '/account/subscription/resume';
  }

  /**
     * Get the current logged in user
     * @return {Promise}
     */
  user() {
    return api.get(this.url);
  }

  /**
     * Update profile
     * @param {*} data 
     * @return {Promise}
     */
  update(data) {
    return api.put(this.url, data);
  }

  /**
     * Cancel account
     * @return {Promise}
     */
  cancel() {
    return api.delete(this.url);
  }

  /**
     * Send a reactivate email request
     * @param {*} data 
     * @return {Promise}
     */
  requestReactivate(data) {
    return api.post(this.url_request_reactivate, data);
  }

  /**
     * Reactivate an account
     * @param {*} data 
     * @return {Promise}
     */
  reactivate(id, signature, expires) {
    return api.get(this.url_reactivate + id + '?expires=' + expires +'&signature=' + signature);
  }

  /**
     * Update account payment info
     * @param {*} params 
     */
  updatePaymentInfo(params = {}) {
    return api.put(this.url_update_payment_info, params);
  }

  /**
     * Create subscription
     */
  subscribe(params = {}) {
    return api.post(this.url_subscription, params);
  }

  /**
     * Swap subscription
     * @param {*} param0 
     */
  swapSubscription(params = {}) {
    return api.post(this.url_subscription_swap, params);
  }

  /**
     * Swap subscription
     * @param {*} param0 
     */
  cancelSubscription() {
    return api.delete(this.url_subscription);
  }

  /**
     * Resume a cancelled sub if still before ends_at period
     * @return {Promise}
     */
  resumeSubscription() {
    return api.post(this.url_subscription_resume);
  }
}

export default new Account;